/**
 * Tailwind class merge helper.
 * Combines clsx (conditional classes) with tailwind-merge (deduplication)
 * so conflicting utility classes resolve correctly.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
